export const stripePublishableKey = process.env.REACT_APP_STRIPE_KEY
  ? process.env.REACT_APP_STRIPE_KEY
  : 'pk_test_1K5zqnzkb72E9LawwOKRfljF';
export const apiUrl = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : 'https://leaderboardapp.ngrok.io/';
export const redirectUrl = process.env.REACT_APP_STRIPE_SUCCESS_URL
  ? process.env.REACT_APP_STRIPE_SUCCESS_URL
  : 'https://leaderboardweb.ngrok.io/settings/';
